










































































































































































































































































































































import Vue from 'vue';
import {
  eventBus,
  eventBusSidebarClick,
  filtroHomeEventBus,
  filtroHomeEvents,
} from '@/setup';
import Confirmation from './Confirmation.vue';
import { Component, Watch } from 'vue-property-decorator';
import config from '@/config/index'; //
import { AxiosVue } from '@/AxiosVue';
import store from '@/store';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
// @ts-ignore
import ListAppsVisibles from '@/config/AppsVisibles.json';
import { LoadingService } from '@/services/loadingService';
import { FilterService } from '@/services/filterServices';
import NotificacionesAlertas from '@/components/plataforma/NotificacionesAlertas.vue';
import ChangePass from '@/views/auth/ChangePass.vue';
import { Vehiculo } from '@/pantallas/Inicio/VehiculosData/fetchVehiculos';
import vehiculoEventBus from '../pantallas/Inicio/VehiculosGrid/vehiculoEventBus';
import VerDetalleModalTab from '@/pantallas/Inicio/Mapa/VerDetalleModalTab.vue';
import { Actividad } from '../pantallas/Inicio/ActividadesData/fetchActividades';
import ActividadesEventBus from '../eventBus/actividadesEventBus';
import { CodigoAccion } from '../views/base/VariablesPermisos';
import ContactoEjecutivo from '@/views/auth/ContactoEjecutivo.vue';
import { ParametroSistemaVm } from '@/interfaces/parametroSistema';
import moment, { Duration } from 'moment';
import CortaCorrienteEventBus from '@/pantallas/Inicio/CortaCorrienteData/CortaCorrienteEventBus';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';

import { fetchSideBar } from '@/pantallas/Inicio/Sidebar/fetchSideBar';
import { fetchRoute } from '@/pantallas/Inicio/Sidebar/fetchRoute';
import { MSResponse } from '@/interfaces/MS';
import { ClientFilterI } from '@/interfaces/Filters';
import { AxiosResponse } from 'axios';
import { setTimeout } from 'timers';
import { MarcaBlanca } from '@/config/marcaBlanca.ts';
import { fetchPassword } from '@/pantallas/Inicio/Sidebar/fetchPassword';

@Component({
  components: {
    'app-confirmacion': Confirmation,
    'app-notificaciones-alertas': NotificacionesAlertas,
    'app-change-pass': ChangePass,
    VerDetalleModalTab,
    'app-contacto-ejecutivo': ContactoEjecutivo,
  },
})
export default class SideBar extends Vue {
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  axiosPy: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  $snotify: any;
  aplicaciones: any = [];
  AppsVisibles: any = [];
  clipped: boolean = true;
  drawer: boolean = false;
  drawerfloat: boolean = true;
  fixed: boolean = false;
  miniVariant: boolean = false;
  logoutDialog: boolean = false;
  title: string = 'Track 3.0';
  clientes: any = [];
  dialogClienteUsuario: boolean = false;
  selectedCliente: any = null;
  nombreCliente: string = '';
  controller: string = 'usuario';
  usuario: any = this.$store.state.user;
  current_dashboard: string = '';
  loadingService = new LoadingService();
  clienteFromStore: number = 0;
  showModalAlertas: boolean = false;
  numeroNotificaciones: number = 0;
  clienteId: number = config.getClienteSesion();
  muestraNumero: boolean = false;
  muestraUsuarios: boolean = false;
  muestraRoles: boolean = false;
  muestraPerfiles: boolean = false;
  mostrarClientes: boolean = true;
  marcaBlanca: MarcaBlanca = new MarcaBlanca();
  mostrarAlertas: boolean = true;
  showModalPass: boolean = false;
  vehiculo: Vehiculo;
  showModalEjecutivo: boolean = false;
  urlDashboard: string = process.env.VUE_APP_URL_DASHBOARD;
  tiempoVisualizacionPopup: number = 0;
  isMobile: string = '';
  showSideBar: boolean = true;
  cargado: boolean = false;
  permisosAux: any = null;
  token: string = '';
  primerIngreso: boolean = false;

  //AXIOS
  axiosNotificacion: AxiosVue = new AxiosVue(ServicioProxy.Notificacion);
  axiosMetabase: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  axiosMetabaseAws: AxiosVue = new AxiosVue(ServicioProxy.MetabaseAws);
  axiosAuth: AxiosVue;
  axiosMs: AxiosVue;
  ControllerCuenta: string = 'Cuenta';

  detalleVehiculoHomeRendered: boolean = false;

  /*Notificaciones Browser */
  colaNotificacionesBrowser: any[] = [];

  private filterService: FilterService = new FilterService();

  constructor() {
    super();
    this.axiosAuth = new AxiosVue(ServicioProxy.Auth);
    this.axiosMs = new AxiosVue(ServicioProxy.MS);
  }

  selectComponent(event: any) {
    if (event.includes('dashboard')) {
      if (this.current_dashboard == '' || this.current_dashboard == event) {
        //
      } else {
        CamaraEventBus.$emit('reloadComponent');
      }
      this.current_dashboard = event;
    }
    if (
      event.includes('camaras') &&
      (event.includes('envivo') || event.includes('operaciones'))
    ) {
      CamaraEventBus.$emit('reloadComponentInLives');
    }
    var self = this;
    setTimeout(() => {
      if (self.$router.currentRoute.fullPath == '/menu') {
        document.getElementById('drawerDivSetup').classList.add('drawer');
      } else {
        document.getElementById('drawerDivSetup').classList.remove('drawer');
      }
    }, 300);
  }

  async mounted() {
    if (this.$router.currentRoute.fullPath == '/menu') {
      document.getElementById('drawerDivSetup').classList.add('drawer');
    } else {
      document.getElementById('drawerDivSetup').classList.remove('drawer');
    }
    if (navigator.userAgent.toLowerCase().match(/mobile/i) != null) {
      this.isMobile = 'mobile';
    }
    if ('/repetir-dia' != this.$route.fullPath) {
      this.loadingService.showLoading();
      this.clienteId = config.getClienteSesion();
      if (this.mostrarAlertas == true) {
        try {
          const response = await this.axiosMetabase.http.get(
            `Metabase/PostgenericA/notificacion_v2/getTotalNoti`
          );
          this.numeroNotificaciones = response.data.data;
          if (this.numeroNotificaciones == 0) {
            this.numeroNotificaciones = null;
            this.muestraNumero = false;
          } else {
            this.muestraNumero = true;
          }
        } catch (error) {
          this.numeroNotificaciones = null;
          this.muestraNumero = false;
        }
      }
      await this.obtenerParametrosSistemaCliente();
      await this.cargaNotificacionesBrowser();
      this.muestraNotificacionesBrowser();
      this.mostrarAdmin();
    }
    let self = this;
    setInterval(function() {
      self.recargaNotificaciones();
    }, 180000);

    vehiculoEventBus.onAbrirDetalleVehiculo(this.handleVerDetalleVehiculo);
    // this.loadingService.hideLoading();
    //await this.getCambioContrasena();
  }

  async getCambioContrasena() {
    let self = this;
    this.loadingService.showLoading();

    return fetchPassword(
      { email: this.usuario.email.toUpperCase() },
      'track3_funcionalidades/getCambioContrasena'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          if (data.data.data[0].validated_password.toString() == 'false') {
            this.showModalPass = true;
            this.primerIngreso = false;
          } else {
            this.primerIngreso = true;
          }
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  async recargaNotificaciones() {
    this.clienteId = config.getClienteSesion();
    if (this.mostrarAlertas == true) {
      try {
        const response = await this.axiosMetabase.http.get(
          `Metabase/PostgenericA/notificacion_v2/getTotalNoti`
        );
        this.numeroNotificaciones = response.data.data;

        if (this.numeroNotificaciones == 0) {
          this.numeroNotificaciones = null;
          this.muestraNumero = false;
        } else {
          this.muestraNumero = true;
        }
      } catch (error) {
        this.numeroNotificaciones = null;
        this.muestraNumero = false;
      }
      this.cargaNotificacionesBrowser();
    }
  }

  async cargaNotificacionesBrowser() {
    const res = await this.axiosMetabase.http.get(
      `Metabase/PostgenericA/notificaciones_alertas_track/NotificacionesBrowserActivas`
    );
    if (res.data) {
      await res.data.forEach((x: any) => {
        if (!this.colaNotificacionesBrowser.some(c => c.id === x.id)) {
          this.colaNotificacionesBrowser.push(x);
        }
      });
      return;
    }
    if (res.data.data) {
      await res.data.data.forEach((x: any) => {
        if (!this.colaNotificacionesBrowser.some(c => c.id === x.id)) {
          this.colaNotificacionesBrowser.push(x);
        }
      });
    }
  }

  muestraNotificacionesBrowser() {
    setTimeout(() => {
      if (this.colaNotificacionesBrowser[0]) {
        this.$snotify.warning(this.colaNotificacionesBrowser[0].mensaje, {
          timeout: this.tiempoVisualizacionPopup * 1000,
        });
        const req = {
          NotificacionId: this.colaNotificacionesBrowser[0].id,
          NotificaBrowserEstado: 2,
        };
        this.axiosMetabase.http
          .put(`Metabase/PostgenericA/notificacion_v2/changeNotiState`, req)
          .catch(error => {
            this.$snotify.error(
              'Ocurrio un error al dejar marcada como leida la notificación'
            );
          });
        this.colaNotificacionesBrowser.splice(0, 1);
      }
      this.muestraNotificacionesBrowser();
    }, this.tiempoVisualizacionPopup * 1000 + 1000);
  }

  get isLogued() {
    return this.$store.getters.isAuthenticated;
  }

  get currentUser() {
    return this.$store.state.name + ' ' + this.$store.state.lastname;
  }

  logoutUserNull() {
    if (
      this.$store.state.user.nombre === null ||
      this.$store.state.user.apellidoPaterno === null
    ) {
      this.$snotify.warning(
        'Por favor póngase en contacto con el Administrador.'
      );
      setTimeout(() => {
        this.$router.push('/login');
      }, 7000);
      this.loadingService.hideLoading();
    }
  }

  updated() {
    this.logoutUserNull();
  }

  async goToHome() {
    var homePath = store.state.homePath;
    if (homePath == null || homePath == '') {
      let axiosGestionUsuario: AxiosVue = new AxiosVue(
        ServicioProxy.GestionUsuario
      );
      await axiosGestionUsuario.http
        .get(`usuario/${this.usuario.id}/homePath`)
        .then(res => {
          homePath = res.data.homePath;
          var homePath = res.data.homePath;
          this.$store.commit('setHomePath', homePath);
        });
    }

    //if (homePath == 'Inicio') window.location.href = window.location.origin;
    //else window.location.href = '/' + homePath;
    window.location.href = '/menu';
  }

  async changeCliente(val: any, restauraHome: boolean = true) {
    if (val != undefined) {
      this.loadingService.showLoading();
      var user = JSON.parse(localStorage.getItem('user'));
      const model = {
        UsuarioId: user.id,
        ClienteId: val,
      };
      const response: any = await this.axiosAuth.http.post(
        `${this.ControllerCuenta}/newtoken`,
        model
      );
      window.localStorage.setItem('token', response.data.token);
      this.$store.commit('setToken', response.data.token);
      store.commit('setStateLoadHomeGrid', false);
      await localStorage.setItem('clienteDefecto', val.toString());
      //this.$router.replace('/');

      filtroHomeEventBus.$emit('borrarGrillaVehiculo');
      this.cerrarCortaCorriente();

      store.commit('setGenerandoRuta', false);
      store.commit('setLimpiarMapa', true);

      store.commit('setCantidadVehiculosHome', 0);
      store.commit('setRepetirDiaAbierto', false);

      filtroHomeEventBus.$emit('cerrarCrearZonaHome');

      if (restauraHome) filtroHomeEventBus.$emit('restaurarEstadoHome');

      await filtroHomeEventBus.$emit('clienteCambio', val);

      await this.chequearPermisosMenuChangeCliente(val);

      this.logoutUserNull();
      this.recargaNotificaciones();
      this.$router.replace('/menu');
      await filtroHomeEventBus.$emit('clienteMultiApp', val);
      filtroHomeEventBus.$emit(filtroHomeEvents.cambiarFiltro);
    }
  }

  validaCliente() {
    if (this.selectedCliente == undefined) {
      this.selectedCliente = this.clienteId;
    }
  }

  async logOutCallback(val: boolean) {
    this.logoutDialog = false;
    if (val) {
      window.localStorage.setItem('logout', '1');

      // Auditar logout por cierre de sesión manual
      await this.axiosPy.http.post('Metabase/PostgenericA/usuario/audit', {
        clientid: store.state.user.clienteDefecto,
        rut_cliente: store.state.user.hasOwnProperty('rutClienteDefecto')
          ? store.state.user.rutClienteDefecto
          : '',
        userid: store.state.user.id,
        email: store.state.user.email,
        event: 'LOGOUT',
        message: 'Cierre de sesión manual por acción de cierre de sesión',
      });
      this.$store.dispatch('logout');
    }
  }

  async created() {
    await this.loadItemsMenu();
    eventBus.$on('changeTitlePage', (title: string) => {
      this.title = title;
    });

    eventBusSidebarClick.$on('collapseSidebar', (collapse: boolean) => {
      this.drawer = false;
      this.drawerfloat = true;
    });

    //Evento que escucha una solicitud de cambio de Cliente (Buscador de Vehículos del Home)
    eventBus.$on('changeClienteBuscadorVehiculo', (cliente: number) => {
      this.selectedCliente = cliente;
      this.changeCliente(cliente, false);
    });
    //---

    var user = JSON.parse(localStorage.getItem('user'));
    if (user.metabaseDashBoardUrl) {
      this.urlDashboard = user.metabaseDashBoardUrl;
    }

    this.getClienteFromUser();

    this.logoutUserNull();

    // regla de negocio, usuario admintrack no debe mostrar clientes y alertas
    this.mostrarClientes = true;
    this.mostrarAlertas = true;
    if (this.usuario.email === 'admintrack@gpschile.com') {
      this.mostrarClientes = false;
      this.mostrarAlertas = false;
    }

    this.permisosAlertasEIgnicion();
    this.token = window.localStorage.getItem('token');
  }

  async loadItemsMenu() {
    this.aplicaciones = store.getters.getAplicaciones;
    this.AppsVisibles = store.getters.getAppsVisibles;
    if (this.aplicaciones == null || this.AppsVisibles == null) {
      await this.getSideBar();
    }
  }

  async getSideBar(clienteId = this.clienteId) {
    let model = {
      idUsuario: this.usuario.id,
      idCliente: clienteId,
      token: store.state.token,
    };
    let sidebarResponse = await fetchSideBar(model);
    this.aplicaciones = await sidebarResponse.data.SideBar;
    this.AppsVisibles = await sidebarResponse.data.AppsVisibles;

    // AppsVisibles contiene una array con los codigos de los modulos fijos que se mostrarán siempre
    // ListAppsVisibles es un json que contiene las acciones de cada modulo en el mismo formato que vendrian desde el SQL, para simular el permiso.
    // se filtran los modulos de ListAppsVisibles que además vengan del MS en AppsVisibles
    // se setean los nuevos permisos en user del store (porque el router para permitir el click valida ahí)
    let permisosFijos = ListAppsVisibles.cliente.filter((x: any) =>
      this.AppsVisibles.includes(x.moduloCodigo)
    );
    if (permisosFijos.length > 0) {
      this.usuario.permisosUsuario.concat(permisosFijos);
      store.commit('setPermisosUsuario', this.usuario.permisosUsuario);

      let user1 = store.getters.getUser;
      user1.permisosUsuario = user1.permisosUsuario.concat(permisosFijos);
      store.commit('setUser', user1);

      this.ChequearPermisosMenuPorModulo(this.usuario.clienteDefecto);
    } else {
      console.log('No hay permisos fijos');
    }

    if (this.aplicaciones.length <= 0) {
      this.$snotify.warning(
        'El cliente seleccionado no tiene aplicaciones asignadas.'
      );
    }
    store.commit('setPermisosUsuario', this.usuario.permisosUsuario);
    store.commit('setAppsVisibles', this.AppsVisibles);
    store.commit('setAplicaciones', this.aplicaciones);
    store.commit('setAppNames', sidebarResponse.data.AppNames);
  }

  async reprocesoPermisoUsuario(clienteId: number) {
    var self = this;
    // await this.axiosAuth.http
    //   .post(
    //     `${this.ControllerCuenta}/usuarioFuncionalidadesCliente/${this.usuario.id}/${clienteId}`
    //   )
    await this.axiosMetabaseAws.http
      .post(`cuenta/usuarioFuncionalidadesCliente`, {
        userId: this.usuario.id,
        clientId: clienteId,
      })
      .then((response: any) => response.data)
      .then(async function(response) {
        ///////////////////////////////////////////////////////////////////////////////////////
        console.log('USUARIOFUNCIONA...', response.data);
        if (window.localStorage) {
          window.localStorage.setItem('token', response.data.token);
          window.localStorage.setItem(
            'user',
            JSON.stringify(response.data.usuario)
          );
          window.localStorage.setItem('clienteDefecto', clienteId.toString());
        }
        self.$store.commit('setToken', response.data.token);
        self.$store.commit('authUser', response.data.usuario);
        self.usuario = response.data.usuario;
        self.permisosAux = response.data.usuario.permisosUsuario.filter(
          (x: any) => x.clienteId === clienteId
        );

        ///////////////////////////////////////////////////////////////////////////////////////
      })
      .catch(function(error) {
        console.log('Error al procesar usuarioFuncionalidadesCliente: ', error);
      })
      .finally(function() {
        self.loadingService.hideLoading();
      });
  }

  //ChequearPermisosMenuPorModulo
  async ChequearPermisosMenuPorModulo(clienteId: number) {
    this.loadingService.showLoading();
    for (let o = 0; o < this.aplicaciones.length; o++) {
      for (let i = 0; i < this.aplicaciones[o].items.length; i++) {
        let item = this.aplicaciones[o].items[i];

        for (let j = 0; j < item.items.length; j++) {
          var menuOpciones1 = item.items[j];
          menuOpciones1.visible = true;
        }
      }

      let ModulosPorcliente = this.usuario.permisosUsuario.filter(
        (x: any) => x.clienteId === clienteId
      );

      if (ModulosPorcliente != undefined) {
        if (ModulosPorcliente.length == 0) {
          await this.reprocesoPermisoUsuario(clienteId);
          ModulosPorcliente = this.permisosAux.filter(
            (x: any) => x.clienteId === clienteId || x.clienteId === -1
          );
        }
      }

      let permisosFijos = ListAppsVisibles.cliente.filter((x: any) =>
        this.AppsVisibles.includes(x.moduloCodigo)
      );
      ModulosPorcliente = ModulosPorcliente.concat(permisosFijos);

      var cantpermisosAplicacion = 0;
      for (let i = 0; i < this.aplicaciones[o].items.length; i++) {
        let item = this.aplicaciones[o].items[i];
        var cantPermisos = 0;
        for (let j = 0; j < item.items.length; j++) {
          var menuOpciones2 = item.items[j];
          var permiso = ModulosPorcliente.find(
            (x: any) =>
              x.moduloCodigo === menuOpciones2.funcionalidad &&
              (x.clienteId === clienteId || x.clienteId === -1)
          );

          /*if (permiso === undefined && !(item.items[j].funcionalidad in this.AppsVisibles)) {
            item.items[j].visible = false;
          } else {
            cantPermisos++;
            cantpermisosAplicacion++;
          }*/
          if (
            permiso !== undefined ||
            item.items[j].funcionalidad in this.AppsVisibles
          ) {
            cantPermisos++;
            cantpermisosAplicacion++;
          } else {
            item.items[j].visible = false;
          }
        }

        if (cantPermisos == 0) {
          this.aplicaciones[o].items[i].visible = false;
        }
        cantPermisos = 0;
      }
      if (cantpermisosAplicacion == 0) {
        this.aplicaciones[o].visible = false;
      }
    }
    this.cargado = true;
    //Evita abrir el menu lateral antes que se renderizuen los permisos.
    this.loadingService.hideLoading();
  }

  getClienteFromUser() {
    if (this.usuario !== null) {
      this.axiosMs.http
        //.get(`usuario/${this.usuario.id}/cliente`)
        .post(
          `Metabase/PostgenericA/searchFilter/get_clients2?user_id=${this.usuario.id}`,
          { user_id: this.usuario.id }
        )
        .then(async res => res.data)
        .then(async res => {
          if (res.CODIGO_RESPUESTA == '2') {
            this.$snotify.warning(res.MENSAJE_RESPUESTA);
            return;
          }
          this.clientes = res.data;

          this.clientes = this.clientes.map((item: any) => {
            let newItem = item;
            newItem.id = parseInt(newItem.id);
            newItem.nombre = item.nombre + ' [' + item.rut + ']';
            return newItem;
          });

          if (res.data.length > 0) {
            var cliente = localStorage.getItem('clienteDefecto');
            if (cliente === null) {
              window.localStorage.setItem(
                'clienteDefecto',
                res.data[0].clienteId
              );
              this.nombreCliente = res.data[0].nombre;
              this.selectedCliente = res.data[0].clienteId;
              this.ChequearPermisosMenuPorModulo(res.data[0].clienteId);
            } else {
              const _cliente = res.data.find(
                (x: any) => x.id === parseInt(cliente)
              );
              await window.localStorage.setItem('clienteDefecto', _cliente.id);
              this.nombreCliente = _cliente.nombre;
              this.selectedCliente = _cliente.id;
              this.ChequearPermisosMenuPorModulo(_cliente.id);
            }

            var showMsgCliente = localStorage.getItem('sendMsgCliente');

            if (showMsgCliente != null) {
              this.dialogClienteUsuario = false;
              localStorage.removeItem('sendMsgCliente');
            } else {
              this.dialogClienteUsuario = false;
            }
          } else {
            this.loadingService.hideLoading();
            this.$snotify.warning(
              'Usuario no posee un cliente asociado, por favor póngase en contacto con el administrador.'
            );
            setTimeout(() => {
              this.$router.push('/login');
            }, 3500);
          }
        })
        .catch(err => {
          this.loadingService.hideLoading();
          //this.$snotify.error("Problemas al obtener cliente del usuario");
        });
    }
    this.filterService
      .getClients('')
      .then((response: AxiosResponse<MSResponse<ClientFilterI>>) => {
        this.$store.commit('setClients', response.data.data);
      })
      .catch(() =>
        this.$snotify.warning('Algunos datos no se cargaron correctamente.')
      );
  }

  goToMiPerfil() {
    this.$router.push('/miperfil');
  }
  gotolink(link: string) {
    this.$router.push(`/${link}`);
  }

  showModalNotificacionesAlertas() {
    this.loadingService.showLoading();
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    this.showModalAlertas = true;
  }

  alertaModalCallback(val: boolean) {
    document.getElementsByTagName('html')[0].style.overflow = 'auto';
    this.showModalAlertas = val;
  }

  // REVISAR LOGICA PARA PERMISOS

  async mostrarAdmin() {
    var list = [2, 3, 4];
    var ModulosPorcliente = this.usuario.permisosUsuario.filter(
      (x: any) => x.clienteId === this.clienteId
    );

    this.muestraPerfiles =
      (await ModulosPorcliente.find(
        (x: any) => x.moduloCodigo == 2 && x.clienteId === this.clienteId
      )) != undefined;
    this.muestraRoles =
      (await ModulosPorcliente.find(
        (x: any) => x.moduloCodigo == 3 && x.clienteId === this.clienteId
      )) != undefined;
    this.muestraUsuarios =
      (await ModulosPorcliente.find(
        (x: any) => x.moduloCodigo == 4 && x.clienteId === this.clienteId
      )) != undefined;

    return false;
  }

  async chequearPermisosMenuChangeCliente(clienteId: number) {
    await this.getSideBar(clienteId);
    const loadingKey = 'chequearPermisosMenuChangeCliente';
    this.loadingService.showLoading(undefined, loadingKey);
    let lastCache = store.state.user;
    let self = this;
    // await this.axiosAuth.http
    //   .post(
    //     `${this.ControllerCuenta}/usuarioFuncionalidadesCliente/${this.usuario.id}/${clienteId}`
    //   )
    await this.axiosMetabaseAws.http
      .post(`cuenta/usuarioFuncionalidadesCliente`, {
        userId: this.usuario.id,
        clientId: clienteId,
      })
      .then((response: any) => response.data)
      .then(async function(response) {
        ///////////////////////////////////////////////////////////////////////////////////////
        if (window.localStorage) {
          window.localStorage.setItem('token', response.data.token);

          const localUser = store.state.user;
          let user: any = {};
          if (localUser.id != undefined || localUser != null) {
            user = Object.assign({}, localUser, response.data.usuario);
          } else {
            user = response.data.usuario;
          }

          window.localStorage.setItem('user', JSON.stringify(user));
          window.localStorage.setItem('clienteDefecto', clienteId.toString());
        }
        self.$store.commit('setToken', response.data.token);
        self.$store.commit('authUser', response.data.usuario);
        self.usuario = response.data.usuario;
        ///////////////////////////////////////////////////////////////////////////////////////

        let funcionalidadPorcliente = response.data.usuario.permisosUsuario.filter(
          (x: any) => x.clienteId === clienteId
        );

        var permisoAlertas = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.Notificaciones &&
            x.clienteId === clienteId
        );
        if (permisoAlertas !== undefined && permisoAlertas !== null) {
          self.mostrarAlertas = true;
          store.commit('setPermisoAlerta', true);
        } else {
          self.mostrarAlertas = false;
          store.commit('setPermisoAlerta', false);
        }

        var permisoHistorico = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.HistoricoMantenimiento &&
            x.clienteId === clienteId
        );
        if (permisoHistorico !== undefined && permisoHistorico !== null) {
          store.commit('setPermisoHistorico', true);
        } else {
          store.commit('setPermisoHistorico', false);
        }

        // Permiso de Facturacion
        var permisoFacturacion = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.Facturacion &&
            x.clienteId === clienteId
        );
        if (permisoFacturacion !== undefined && permisoFacturacion !== null) {
          store.commit('setPermisoFacturacion', true);
        } else {
          store.commit('setPermisoFacturacion', false);
        }

        // Permiso de Solicitudes
        var permisoSolicitudes = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.Solicitudes &&
            x.clienteId === clienteId
        );
        if (permisoSolicitudes !== undefined && permisoSolicitudes !== null) {
          store.commit('setPermisoSolicitudes', true);
        } else {
          store.commit('setPermisoSolicitudes', false);
        }

        // Permiso de Chat
        var permisoChat = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.Chat && x.clienteId === clienteId
        );
        if (permisoChat !== undefined && permisoChat !== null) {
          store.commit('setPermisoChat', true);
        } else {
          store.commit('setPermisoChat', false);
        }

        //566 - Home - Refresco de mapa
        var permisoCrearZona = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.Zonas &&
            x.clienteId === clienteId
        );

        if (permisoCrearZona !== undefined && permisoCrearZona !== null)
          store.commit('setPermisoCrearZonaHome', true);
        else store.commit('setPermisoCrearZonaHome', false);
        //---

        // permisos Inicio
        var permisoHomeIndicadores = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.Inicio &&
            x.accionCodigo === CodigoAccion.Indicadores &&
            x.clienteId === clienteId
        );

        if (
          permisoHomeIndicadores !== undefined &&
          permisoHomeIndicadores !== null
        ) {
          store.commit('setPermisoIndicadores', true);
        } else {
          store.commit('setPermisoIndicadores', false);
        }

        var permisoHomeRepetirDia = funcionalidadPorcliente.find(
          (x: any) =>
            x.moduloCodigo === Funcionalidades.Inicio &&
            x.accionCodigo == CodigoAccion.RepetirDia &&
            x.clienteId === clienteId
        );

        if (
          permisoHomeRepetirDia !== undefined &&
          permisoHomeRepetirDia !== null
        ) {
          store.commit('setPermisoRepetirDia', true);
        } else {
          store.commit('setPermisoRepetirDia', false);
        }
        //---

        await self.ChequearPermisosMenuPorModulo(clienteId);
      })
      .catch(function(error) {
        console.log('Error al procesar usuarioFuncionalidadesCliente: ', error);
      })
      .finally(function() {
        self.loadingService.hideLoading(loadingKey);

        if (store.state.user !== null) {
          self.axiosPy.http.post('Metabase/PostgenericA/usuario/audit', {
            clientid: lastCache.clienteDefecto,
            rut_cliente: store.state.user.hasOwnProperty('rutClienteDefecto')
              ? store.state.user.rutClienteDefecto
              : '',
            userid: store.state.user.id,
            email: store.state.user.email,
            event: 'CAMBIO_CLIENTE',
            message:
              lastCache.rutClienteDefecto +
              ' => ' +
              store.state.user.rutClienteDefecto,
          });
        }
      });
  }

  permisosAlertasEIgnicion() {
    this.clienteId = config.getClienteSesion();

    let modulosPorcliente = this.usuario.permisosUsuario.filter(
      (x: any) => x.clienteId === this.clienteId
    );
    //Consulta por permisos de alerta
    var permisoAlertas = modulosPorcliente.find(
      (x: any) =>
        x.nombreAccion === 'Consultar' &&
        x.accionCodigo === 1 &&
        x.moduloCodigo === Funcionalidades.Notificaciones &&
        x.clienteId === this.clienteId
    );
    if (permisoAlertas !== undefined && permisoAlertas !== null) {
      this.mostrarAlertas = true;
      store.commit('setPermisoAlerta', true);
    } else {
      this.mostrarAlertas = false;
      store.commit('setPermisoAlerta', false);
    }
    //Consulta por permisos de Ignicion
    var permisoIgnicion = modulosPorcliente.find(
      (x: any) =>
        x.nombreAccion === 'Corte de segunda ignición' &&
        x.accionCodigo === 7 &&
        x.moduloCodigo === Funcionalidades.Inicio &&
        x.clienteId === this.clienteId
    );

    if (permisoIgnicion !== undefined && permisoIgnicion !== null) {
      //this.mostrarAlertas = true;
      store.commit('setPermisoIgnicion', true);
    } else {
      //this.mostrarAlertas = false;
      store.commit('setPermisoIgnicion', false);
    }

    //Consulta por permisos de Ignicion
    var permisoIndicadores = modulosPorcliente.find(
      (x: any) =>
        x.nombreAccion === 'Indicadores' &&
        x.accionCodigo === 8 &&
        x.moduloCodigo === Funcionalidades.Inicio &&
        x.clienteId === this.clienteId
    );

    if (permisoIndicadores !== undefined && permisoIndicadores !== null) {
      store.commit('setPermisoIndicadores', true);
    } else {
      store.commit('setPermisoIndicadores', false);
    }

    var permisoHistorico = modulosPorcliente.find(
      (x: any) =>
        x.moduloCodigo === Funcionalidades.HistoricoMantenimiento &&
        x.nombreAccion === 'Consultar' &&
        x.accionCodigo === 1 &&
        x.clienteId === this.clienteId
    );
    if (permisoHistorico !== undefined && permisoHistorico !== null) {
      store.commit('setPermisoHistorico', true);
    } else {
      store.commit('setPermisoHistorico', false);
    }

    // Permiso de Facturacion
    var permisoFacturacion = modulosPorcliente.find(
      (x: any) =>
        x.moduloCodigo === Funcionalidades.Facturacion &&
        x.nombreAccion === 'Consultar' &&
        x.accionCodigo === 1 &&
        x.clienteId === this.clienteId
    );
    if (permisoFacturacion !== undefined && permisoFacturacion !== null) {
      store.commit('setPermisoFacturacion', true);
    } else {
      store.commit('setPermisoFacturacion', false);
    }

    // Permiso de Solicitudes
    var permisoSolicitudes = modulosPorcliente.find(
      (x: any) =>
        x.moduloCodigo === Funcionalidades.Solicitudes &&
        x.nombreAccion === 'Consultar' &&
        x.accionCodigo === 1 &&
        x.clienteId === this.clienteId
    );
    if (permisoSolicitudes !== undefined && permisoSolicitudes !== null) {
      store.commit('setPermisoSolicitudes', true);
    } else {
      store.commit('setPermisoSolicitudes', false);
    }

    // Permiso de Chat
    var permisoChat = modulosPorcliente.find(
      (x: any) =>
        x.moduloCodigo === Funcionalidades.Chat &&
        x.nombreAccion === 'Consultar' &&
        x.accionCodigo === 1 &&
        x.clienteId === this.clienteId
    );
    if (permisoChat !== undefined && permisoChat !== null) {
      store.commit('setPermisoChat', true);
    } else {
      store.commit('setPermisoChat', false);
    }
  }
  eventoAux() {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    this.showModalPass = true;
  }

  eventoEjecutivo() {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    this.showModalEjecutivo = true;
  }

  moduloCallbackEjecutivo(val: boolean) {
    this.showModalEjecutivo = val;
  }

  moduloCallback(val: boolean) {
    this.showModalPass = val;
  }

  cerrarCortaCorriente() {
    const data: any = {
      show: false,
      vehiculoId: 0,
      showCorteIgnicion: false,
      fechaRecepcion: null,
      usuarioId: 0,
      dataComunicacion: {
        mensajeTxt: '',
        fechaSolicitudTxt: '',
        estadoTxt: '',
        usuarioTxt: '',
      },
    };
    // store.commit('setRepetirDiaAbierto', false);
    //actividadesEventBus

    CortaCorrienteEventBus.abrirCortaCorrienteHome(data);
    store.commit('setCortaCorrienteAbierto', false);
    store.commit('setCortaCorrienteAbiertoAux', false);

    /*ActividadesEventBus.$emit('setCortaCorrienteOpen', {
        show: data,
      });*/
  }

  handleVerDetalleVehiculo(
    vehiculo: Vehiculo,
    actividades: Actividad,
    ultimaActividad: Actividad,
    show: boolean
  ) {
    this.vehiculo = vehiculo;
    this.detalleVehiculoHomeRendered = show;
  }

  handleCerrarVerDetalle() {
    vehiculoEventBus.abrirDetalleVehiculo(
      this.vehiculo,
      null,
      null,
      false,
      '0'
    );
    this.detalleVehiculoHomeRendered = false;
  }

  obtenerParametrosSistemaCliente() {
    return this.axios.http
      .get<ParametroSistemaVm>(`ParametroSistema/${this.clienteId}/cliente`)
      .then((ps: any) => {
        this.tiempoVisualizacionPopup = this.obtenerMoment(
          ps.data.tiempoVisualizacionPopup
        ).asSeconds();
      })
      .catch(error => {});
  }

  tieneHijos(p: any) {
    return p.length > 1;
  }

  private obtenerMoment(valor: string): Duration {
    const regexHoras: RegExp = /^[0-9][0-9]:[0-9][0-9]:[0-9][0-9]$/;

    if (regexHoras.test(valor)) {
      return moment.duration(moment(valor, 'HH:mm:ss').format('HH:mm:ss'));
    }

    return moment.duration(moment(valor, 'DD.HH:mm:ss').format('DD.HH:mm:ss'));
  }

  get areApplicationUpdated(): boolean {
    return this.$store.getters.getApplicatenUpdated;
  }

  @Watch('areApplicationUpdated')
  watchAreApplicationUpdated() {
    this.getSideBar();
  }

  get valideSubDomain(): boolean {
    var subdominio = this.marcaBlanca.getSubDomain();
    switch (subdominio) {
      case 'gpschile':
        return true;
      default:
        return false;
    }
  }
}
